import Vue from 'vue';

Vue.component('ProgressBar', {
  template: `
  <div class="lp--progress-progressBar">
    <div class="lp--progress-progressBar-initiated" v-bind:style="{width: ''+progress.initiated*100+'%'}"></div>
    <div class="lp--progress-progressBar-completed" v-bind:style="{width: ''+progress.completed*100+'%'}"></div>
  </div>
  `,
  props: ['progress'],
});
